import React, { useState, useContext } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonUI from "../../material-ui/ButtonUI";
import { AuthContext } from "../../../context/Auth/AuthContext";
import permanentlyDeleteUser from "../../../api/permanentlyDeleteUser";

const BulkPermanentDeletePopup = ({
  setUserDeletedToTrue,
  Userbulkid = [],
  bulkPermanentDeleteUser,
  setBulkPermanentDeleteUser,
  setRowSelection
}) => {
  const { token } = useContext(AuthContext);

  const handleClose = () => {
    setBulkPermanentDeleteUser(false);
  };

  const onBulkPermanentDelete = async (Userbulkid) => {
    const permanentDeleteAllUserFormResponse = await permanentlyDeleteUser({
      token: token,
      id: Userbulkid,
    });

    if (permanentDeleteAllUserFormResponse.code === 200) {
      setRowSelection({});
      setBulkPermanentDeleteUser(false);
      setUserDeletedToTrue();
      showSuccess("User/s deleted permanently");
    } else {
      showError("Error while bulk deleting user/s permanently");
    }
  };

  return (
    <div className="dialog-modal">
      <Dialog
        open={bulkPermanentDeleteUser}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <MdDelete />
          </div>
          <div className="popup-header-title">Permanently Delete User</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to permanently delete these users ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{ marginTop: "15px" }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{ marginTop: "15px" }}
            autoFocus={true}
            onClickFunc={() => {
              onBulkPermanentDelete(Userbulkid);
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BulkPermanentDeletePopup;
